import { render } from "./App.vue?vue&type=template&id=f2de961c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f2de961c&lang=scss"
import "@/assets/styles/main.scss?vue&type=style&index=1&lang=scss"
script.render = render

export default script